import React, {useState,useEffect} from 'react';
import '../../../App.css';
import { formatDisplayTS } from '../../common/Utilities';

const TimeDisplay = props => {
  const [date, setDate] = useState('')
  const [time, setTime] = useState('')

  const getDateTime = () => {
    const formattedTS = formatDisplayTS()
    // const formattedTS = '2024-01-23 12:22:36'
    setDate(formattedTS.substring(0, 10))
    setTime(formattedTS.substring(11))
  };

  useEffect(() => {
    const clockTimer = setInterval(getDateTime,1000)
    return () => clearInterval(clockTimer);
  }, [time]);

  return (
    <div style={styles.container}>
    <div>
      <div>Date</div>
      <div>{date}</div>
    </div>
      <div>
        <div>Current Time</div>
        <div>{time}</div>
      </div>
    </div>
  )
}

export default TimeDisplay;

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '2vmin',
    fontSize: '1.4vmin',
    fontWeight: 'bold',
    color: 'white',
  },
}